$(function () {
	function toggleSettingsVisibility() {
		$(".hidden-settings").slideToggle(400, function () {
			updateLinkText();
		});
	}

	function updateLinkText() {
		const link = $(".show-hide-settings");
		link.find('.show-options').toggle();
		link.find('.hide-options').toggle();
	}

	$(".show-hide-settings").on("click", function (e) {
		e.preventDefault();
		toggleSettingsVisibility();
	});
})